module.exports = __webpack_public_path__ + "img/file__icon-image.15d1de14.svg";